import { COMMON_API_BASE_URL } from '@env';
import { type CommonModuleTypes } from '@marpla/api-sdk';
import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQueryWith401Retry } from './rtk-query-api';

export const permissionApi = createApi({
  reducerPath: 'permissionApi',
  baseQuery: createBaseQueryWith401Retry(`${COMMON_API_BASE_URL}/`),
  tagTypes: ['Permission'],
  endpoints: (builder) => ({
    addToken: builder.mutation<unknown, { token: string; moduleTypes: CommonModuleTypes[] }>({
      query: (body) => ({
        url: `permission/permissions/token`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Permission'],
    }),
    changeToken: builder.mutation<
      unknown,
      { permissionId: string; token: string; moduleTypes: CommonModuleTypes[] }
    >({
      query: ({ permissionId, token, moduleTypes }) => ({
        url: `permission/permissions/token/${permissionId}`,
        method: 'PUT',
        body: { token, moduleTypes },
      }),
      invalidatesTags: ['Permission'],
    }),
    changeModuleType: builder.mutation<
      unknown,
      { permissionId: string; moduleTypes: CommonModuleTypes[] }
    >({
      query: ({ permissionId, moduleTypes }) => ({
        url: `permission/permissions/token/${permissionId}/module_types`,
        method: 'PUT',
        body: { moduleTypes },
      }),
      invalidatesTags: ['Permission'],
    }),
  }),
});

export const { useAddTokenMutation, useChangeTokenMutation, useChangeModuleTypeMutation } =
  permissionApi;
